import { LeftRightBasedExpression } from '../LeftRightBasedExpression.js';
export class MultiplyExpression extends LeftRightBasedExpression {
    evaluate(visitor, localVariables) {
        const { left, right } = this._evaluateLeftRightExpression(visitor, localVariables);
        return left * right;
    }
}
//# sourceMappingURL=MultiplyExpression.js.map